import { useEffect, useState, useCallback } from "react";

export const useIsScrolled = () => {
  const isClient = typeof window === 'object';
  if (!isClient) {
    return false;
  }

  const getScroll = useCallback(
    () => ({
      x: isClient ? window.scrollX : undefined,
      y: isClient ? window.scrollY : undefined
    }),
    [isClient]
  );

  const [windowScroll, setWindowScroll] = useState(getScroll);

  useEffect(() => {
    if (!isClient) {
      return false;
    }

    const handleScroll = () => {
      setWindowScroll(getScroll());
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isClient, getScroll]);

    return windowScroll;
};

export default useIsScrolled;
